import { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const useFetchSuggestTours = (params) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {
        if (!params || !params.tour || !params.city) return;

        const fetchData = async () => {
            setLoading(true);
            const { REACT_APP_BASE_URL } = process.env;
            const token = localStorage.getItem('token');
            try {
                const response = await axios.get(`${REACT_APP_BASE_URL}/index.php`, {
                    params: {
                        r: 'api/tours/suggests',
                        tour: params.tour,
                        city: params.city,
                        lng: i18n.language,
                        limit: params.limit,
                    },
                    headers: {
                        'x-authorization-token': token,
                        'Content-Type': 'application/json',
                    },
                });
                setData(response.data);
            } catch (error) {
                console.error('Error fetching suggested tours:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [params]);

    return data;
};

export default useFetchSuggestTours;
